import { Component, OnInit, ViewChild, ViewChildren, TemplateRef, ChangeDetectorRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from "@angular/forms";
import { OnboardService } from "./onboard.service";
import { Observable, zip, forkJoin } from "rxjs";
import { BaseCRUDComponent } from "../../Core/Abstract/baseCRUD.component";
import { EventsEmitterService } from "../../Core/Abstract/emitter.service";
import { LogService } from "../../Core/Abstract/log.service";
import { VisualsService } from "../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { OnboardFilesComponent } from "./OnboardFiles/onboardfiles.component";
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import 'rxjs/add/operator/takeUntil'
import { Subject } from 'rxjs'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: "onboardEdit-grid",
  templateUrl: "./onboard.component.html",
  styleUrls: ["./onboard.component.css"],
  providers: [OnboardService]
})
export class OnboardEditComponent extends BaseCRUDComponent<OnboardService>
    implements OnInit {

  termsFileName: string;

  constructor(
      private securityService: SecurityService,
      private modalService: BsModalService,
      private cdr: ChangeDetectorRef,
      private service: OnboardService,
      private eventsEmitterService: EventsEmitterService,
      private configService: ConfigService,
      fb: FormBuilder,
      logger: LogService,
      visualsService: VisualsService,
      route: ActivatedRoute,
      router: Router
  ) {
    super(logger, visualsService, route, fb, router);
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.service.getTerms(this.userId).subscribe(res => {
      this.termsFileName = res.data;
    });
    this.isOrigin = this.route.snapshot.queryParamMap.get('isOrigin');
    this.group = 'onboardEdit';
    this.logoUrl = 'assets/images/logo/' + this.configService.getClient() + '/logo.png';
    this.entitiesPosition = this.configService.getEntitiesPosition();
    this.profile = this.configService.getClient();
    this.enableCopyFromButton = eval(this.configService.getEnableCopyFromButton());
    let userListParsed = JSON.parse(localStorage.getItem('userList'));
    this.userList =  userListParsed.length >=1 ? userListParsed.filter(el => el.status != 'PND' && el.userId != this.userId) : userListParsed;
    this.getIsNotLookUpList();
    this.eventsEmitterService.languageChange.subscribe(langId => {
      if(this.loading){
        return;
      }
      this.loadVisuals();
      this.getIsNotLookUpList();
      const formFields = JSON.parse(localStorage.getItem('formlyForm'));
      this.model = Object.assign({}, ...this.form.getRawValue());
      this.model = Object.assign({}, this.model , {customerType : localStorage.getItem('customerType')});
      this.mapForm(formFields);
      this.calculateStepper(this.model);
      this.getDocumentList(this.model.cmpTp);
    });
    this.getFormConfigAndData();
    this.getValidationType();
    this.getStatus(this.userId);
  }
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild(OnboardFilesComponent, {static: false}) public fileComponent: OnboardFilesComponent;
  @ViewChild('autoShownModal', {static: false}) autoShownModal: ModalDirective;
  @ViewChild('termsDocModal', {static: false}) public termsDocModal: ModalDirective;
  @ViewChild('termsDocModal2', {static: false}) public termsDocModal2: ModalDirective;
  @ViewChild('copyFromModal', {static: false}) public copyFromModal: ModalDirective;

  modalRef: BsModalRef;
  isModalShown = false;
  isCopyDocuments = false;

  form: any;
  form2;
  form3;
  options: FormlyFormOptions = { formState: { disabled: false }};
  options2: FormlyFormOptions = { formState: { disabled: true } };
  activedStep = 0
  model: any;
  model2: any;
  model3: any;
  fields: FormlyFieldConfig[];
  fields3: FormlyFieldConfig[];
  ind = 1
  submitting: boolean = false;
  enableCopyFromButton: boolean = false;
  documentList = [];
  stepper = []
  groupDocsList = []
  loadingDocTerms: boolean = false;
  loading: boolean = false;
  logoUrl:any;
  protected companyTypeList = [];
  protected statusList = [];
  protected bankList = [];
  protected swiftList = [];
  protected profile: string = 'demo';
  protected entitiesPosition;
  validation
  status: any;
  userId: any;
  isOrigin: any;
  documentListGrouped=[];

  clonedId: number;
  userList = [];

  public showDocsTermsModal(): void {
    this.termsDocModal.show();
  }

  public hideDocsTermsModal(): void {
    this.termsDocModal.hide();
  }

  public showDocsTermsModal2(): void {
    this.termsDocModal2.show();
  }

  public hideDocsTermsModal2(): void {
    this.termsDocModal2.hide();
  }

  downloadTermsFile() {
    this.service.downloadTermsFile(this.userId, this.termsFileName).subscribe(res => res);
  }

  showModal(): void {
    this.isModalShown = true;

  }

  hideModal(): void {
    this.autoShownModal.hide();
  }

  onHidden(): void {
    this.isModalShown = false;
  }

  getIsNotLookUpList() {
    this.companyTypeList = this.visualsService.getLkpFromStorageAsJSON('LKP_LEGAL_FORM', true).filter((type) => {
      if (!type.id.includes(':')) {
        return type;
      }
    });
    this.statusList = this.visualsService.getLkpFromStorageAsJSON('LKP_REG_USER_S_STATUS', true);
    this.groupDocsList = this.visualsService.getLkpFromStorageAsJSON('LKP_CMP_DOC_GROUP_GENERAL_DOC_TYPE', true);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
  getValidationType() {
    this.visualsService.getParam('DOCUMENTS_VALIDATION').subscribe((res) => {
      this.validation = res.paramValStr
    })
  }
  getStatus(id) {
    this.service.getStatus(id).subscribe((res) => {
      this.status = res.data
    })
  }

  getFormConfigAndData() {
    this.loading = true;
    forkJoin(this.service.loadBean(this.userId), this.service.getBankbyText(), this.service.getSwiftCodes()).subscribe(response => {
      let arrayToObject = JSON.parse(response[0].data.dataChar);
      this.bankList = response[1].data
      this.swiftList = response[2].data.map(el => ({ id: el.swiftCode, text: el.swiftCode, bankId: el.id }));
      this.model = Object.assign({}, ...arrayToObject);
      localStorage.setItem('status', this.model.status);
      localStorage.setItem('customerType', this.model.customerType ? this.model.customerType : '');
      this.model2 = Object.assign({}, ...arrayToObject);
      this.service.getFields(this.userId).subscribe(res => {
        localStorage.setItem('formlyForm',res.data.valForm);
        this.mapForm(JSON.parse(res.data.valForm));
        this.form = new FormArray(this.fields.map(() => new FormGroup({})));
        this.model.status == 'RG' ? '' : this.options.formState.disabled = true;
        this.form2 = new FormArray(this.fields.map(() => new FormGroup({})));
        this.calculateStepper(this.model);
        this.loading = false
      },
        error => this.loading = false,
        () => {
          this.getDocumentList(this.model.cmpTp);
        }
      )
    },
      error => this.loading = false)
  }
  mapForm(data){
    this.fields = this.mapFields(data);
    this.stepper = Object.assign([],  this.fields);
  }
  calculateStepper(model){
    this.stepper = this.stepper.filter((a)=>{return !eval(a.showStep) ;});
  }
  loadingTerms = false
  getTermsFormConfigAndData() {
    this.loadingTerms = true
    forkJoin(
      this.service.getTermsFields(this.userId), this.service.loadTermsBean(this.userId)).subscribe(
        response => {
          this.fields3 = this.mapFields(JSON.parse(response[0].data.valForm));
          this.form3 = new FormArray(this.fields3.map(() => new FormGroup({})));
          let arrayToObject = response[1].data ? JSON.parse(response[1].data.dataChar) : [{"isAgreed":"N","isSCF":"N","isClientOfBank":"N"}];
          this.model3 = Object.assign({}, ...arrayToObject);
          this.loadingTerms = false
        },
        error => console.log("Error: ", error),
        () => {
        }
      )
  }
  submitForm() {
    this.termsDocModal.hide();
    this.loading = true;
    let formToSend = this.form.getRawValue()
    let formTermsToSend = this.form3.getRawValue()
    formToSend.splice(-1, 1)
    formToSend[0]['status'] = 'AUD1'
    this.service.save(formToSend, this.userId).subscribe(() => {
      this.activedStep = 0;
      LogService.emitAlert({
        type: "success",
        body: this.genericVisuals.dataSubmitted
      });
      this.getStatus(this.userId)
      this.getFormConfigAndData()
      this.service.saveTerms(formTermsToSend, this.userId).subscribe(() => {
      })
      this.submitting = false

    },
      error => {
        this.loading = false;
        LogService.emitAlert({
          type: "danger",
          body: "Something went wrong"
        });
      })
  }
  save() {
    let formToSend = this.form.getRawValue()
    formToSend.splice(-1, 1)
    this.service.save(formToSend, this.userId).subscribe(() => {
      LogService.emitAlert({
        type: "success",
        body: this.genericVisuals.dataSaved
      });
    },
      error => {
        LogService.emitAlert({
          type: "danger",
          body: "Something went wrong"
        });
      })
  }
  backToTerms() {
    this.securityService.router.navigate(['/menu/welcomeScreen'], { queryParams: { userId: this.userId, ob: true } });
  }

  ddd: boolean
  submit() {
    this.submitting = true
    this.form2.disable();
    this.model2 = Object.assign({}, ...this.form.getRawValue());
    this.model2.status = 'AUD1'
    if (!this.form.valid) {
      return
    }
    this.getTermsFormConfigAndData();
    this.termsDocModal.show();
  }
  setActive(index) {
    this.activedStep = index
    if(index == this.stepper.length-1){
      this.getDocumentList('')
    }
  }
  nextStep() {
    this.activedStep = this.activedStep + 1
    if(this.activedStep == this.stepper.length-1){
      this.getDocumentList('')
    }
  }
  backStep() {
    this.activedStep = this.activedStep - 1
  }

  getDocTerms() {
    this.termsDocModal2.show();
  }

  getDocumentList(event) {
    let formData = this.form.getRawValue();
    let isAdmin = formData[this.entitiesPosition.isAdmin].isAdmin;
    let cmpTp = formData[this.entitiesPosition.cmpTp].cmpTp;
    let otherField = this.profile == 'abc' ? formData[this.entitiesPosition.otherField].accountingBooks : null;
    let dataToSend = this.profile == 'abc' ? cmpTp +':'+ otherField : cmpTp; 
    this.service.getDocumentList(dataToSend, isAdmin, this.userId)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        data => {
          this.documentList = data.data;
          this.manipulateDocs();
        },
        error => { }
      );
  }

  manipulateDocs(){
    if (this.fields[this.fields.length - 1]['fields'].length) {
      this.fields[this.fields.length - 1]['fields'].splice(0, this.fields[this.fields.length - 1]['fields'].length)
    }
    Object.keys(this.documentList).forEach((key, index) => {
      this.fields[this.fields.length - 1]['fields'] =
        [
          ...this.fields[this.fields.length - 1]['fields'],
          {
            "className": "section-label",
            "template": `<strong>${this.groupDocsList.find((x: any) => x.id == key) ? this.groupDocsList.find((x: any) => x.id == key).text : null}</strong><hr/>`
          },
          {
            'fieldGroup': [],
            "fieldGroupClassName": "row"
          }
        ];
      this.ind = index == 0 ? 1 : this.ind + 2;
      (this.documentList[key]).forEach((log) => {
        this.documentListGrouped =  this.groupBy(this.documentList[key],'docId');
      })
      Object.keys(this.documentListGrouped).forEach((rr, index) => {
        (this.documentListGrouped[rr]).forEach((log,index) => {
          if(this.documentListGrouped[rr].length>1 && index == 0){
              this.fields[this.fields.length - 1]['fields'][this.ind]['fieldGroup'] =
              [
                ...this.fields[this.fields.length - 1]['fields'][this.ind]['fieldGroup'],
                {
                  "key": log.docId,
                  "type": "file",
                  "multiple":true,
                  "className": "col-md-4",
                  "templateOptions": {
                    "required": log.isNotMandatory == 'Y' ? false : (this.validation == 'ALL' ? !(this.documentList[key].find((x: any) => x.docId == log.docId).regCmpDocId != null) : null),
                    "regCmpDocId": log.regCmpDocId,
                    "label": log.docId,
                    "options": this.documentList,
                    "docType": log.generalDocType,
                    "userId": this.userId,
                    "status": this.model.status,
                    "multiple":this.documentListGrouped[rr]
                  }
                }
              ];
            
          }
          else if(this.documentListGrouped[rr].length<=1){
            this.fields[this.fields.length - 1]['fields'][this.ind]['fieldGroup'] =
            [
              ...this.fields[this.fields.length - 1]['fields'][this.ind]['fieldGroup'],
              {
                "key": log.docId,
                "type": "file",
                "multiple":false,
                "className": "col-md-4",
                "templateOptions": {
                  "required": log.isNotMandatory == 'Y' ? false : (this.validation == 'ALL' ? !(this.documentList[key].find((x: any) => x.docId == log.docId).regCmpDocId != null) : null),
                  "regCmpDocId": log.regCmpDocId,
                  "label": log.docId,
                  "options": this.documentList,
                  "docType": log.generalDocType,
                  "userId": this.userId,
                  "status": this.model.status
                }
              }
            ];
          }
        })
      })
    })
    this.form = new FormArray(this.fields.map(() => new FormGroup({})));
    this.form2 = new FormArray(this.fields.map(() => new FormGroup({})));
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  selectBankOrSwiftCd(name,event,index){
    let obj;
    let filteredKey = name=='swift' ? 'swiftCode' : 'id';
    if(name === 'swift'){
      obj = this.bankList.find((x: any) => x.id == event.bankId)
    } else {
      obj = this.swiftList.find((x: any) => x.id.includes(event.swiftCode));
    }
    this.form.controls.forEach((element,i) => {
      if(element.controls.hasOwnProperty('cmpBankAccount')){
        if(name === 'swift'){
          this.form.controls[i].controls.cmpBankAccount.controls[index.parent.key].controls.bankId.setValue(obj.id);
        } else {
          this.form.controls[i].controls.cmpBankAccount.controls[index.parent.key].controls.swiftCode.setValue(obj.id);
        }
        
        this.form.controls[i].controls.cmpBankAccount.controls[index.parent.key].controls.ibanRequired.setValue(obj.ibanReq == 'Y');
      }
    });
  }

  cloneData(data) {
    this.loading = true;
    this.service.getClonedData(data, this.userId)
        .subscribe(res => {

          this.model =  Object.assign({}, ...JSON.parse(res.data));
          this.loading = false;
        }, err => {
          console.log(err)
          this.loading = false;
        });
  }
}
